exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ml-15[data-v-5b580864]{margin-left:15px}.fl-r[data-v-5b580864]{float:right}.mt-20[data-v-5b580864]{margin-top:20px}#print[data-v-5b580864]{display:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-5b580864","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/pharmacy/bills/index.vue
// module id = sJdM
// module chunks = 53 239